import React from "react";
import { useSelector } from "react-redux";
import MatchNew from "./MatchNew";
import MatchExisting from "./MatchExisting";

const Match = ({ clickToClose, initialMappingData }) => {
  const existingJobDetails = useSelector(
    (state) => state.fileUpload.existingjobDetails
  );

  return (
    <>
      {existingJobDetails ? (
        <MatchExisting clickToClose={clickToClose} initialMappingData={existingJobDetails.fieldMapping} />
      ) : (
        <MatchNew
          clickToClose={clickToClose}
          initialMappingData={initialMappingData}
        />
      )}
    </>
  );
};

export default Match;
